import { ActionsType } from '@tock/shared/utils/connect';
import BaseComponent from '@tock/shared/components/BaseComponent';
import Field from '@tock/shared/components/forms/Field';
import clsx from 'clsx';

interface RevalidateCVVProps {
  actions: ActionsType;
  cvcField: ReduxFormField<string>;
}

interface RevalidateCVVState {
  braintreeError: boolean;
}

export class RevalidateCVV extends BaseComponent<RevalidateCVVProps, RevalidateCVVState> {
  constructor(props: RevalidateCVVProps) {
    super(props);
    this.state = { braintreeError: false };
  }

  createHostedField(container: HTMLElement) {
    if (!container) {
      return;
    }
    this.props.actions.paymentCard
      .createBraintreeHostedField()
      .then(() => {
        this.setState({ braintreeError: !window.braintreeHostedField });

        if (window.braintreeHostedField) {
          window.braintreeHostedField.on('focus', () => {
            const { cvcField } = this.props;
            cvcField.error = undefined;
            cvcField.invalid = false;
            cvcField.onChange(null);
          });
        }
      })
      .catch(() => this.setState({ braintreeError: true }));
  }

  componentWillUnmount() {
    delete window.braintreeHostedField;
  }

  render() {
    if (this.state.braintreeError) {
      return null;
    }

    const { cvcField } = this.props;
    const className = clsx(
      'ConsumerCheckout-revalidateCVVInput TextInput-input TextInput--default FSHide',
      { 'has-errors': cvcField.error }
    );
    return (
      <Field
        label="Please confirm your credit card security code"
        labelFor="cvc"
        className="ConsumerCheckout-revalidateCVVForm"
        field={cvcField}
      >
        <span className={className} id="cvv" ref={this.createHostedField} />
      </Field>
    );
  }
}
